import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';

import RejectRegistrationProductProperty from '../../../../views/product/common/modal/RejectRegistrationProductProperty';
import withModal from '../../../../lib/hoc/withModal';
import { productActions } from '../../../../store/modules/product';

class RejectRegistrationProductPropertyModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //--> 상품 태그 거절 사유 타입
      type: 0,
      //--> 상품 태그 거절
      reason: null,
    };
  }

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'rejectRegistrationProductPropertyModal', value: false });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    return (
      <RejectRegistrationProductProperty
        {...this.state}
        {...this.props}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.product.rejectRegistrationProductPropertyModal.isOpen,
    data: state.product.rejectRegistrationProductPropertyModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: productActions.toggleModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(RejectRegistrationProductPropertyModalContainer)));
